import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MatRipple } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';
import { APP_CONFIG } from '@core/config/app-config.token';

@Component({
  selector: 'recrewt-bordered-icon-button',
  templateUrl: './bordered-icon-button.component.html',
  styleUrls: ['./bordered-icon-button.component.scss'],
  imports: [MatRipple, MatIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BorderedIconButtonComponent {
  private appConfig = inject(APP_CONFIG);

  readonly icon = input<string>();

  readonly color = input(this.appConfig.theme.accent);

  /** Accessible name for the button — required for icon-only usage. */
  readonly label = input<string>();

  readonly foreground = input<string>();
}
